import { apiResponseToError } from '@/utils/api'

export const bundlePurchase = async(params: BundlePurchaseParams): Promise<BundleOrder> => {
    const endpoint = '/wp-json/wr-cart/order/bundle'

    const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify(params),
    })
    return await apiResponseToError(response)
}
